import jwt_decode from 'jwt-decode';

/**
 * Decoded payload from `adminToken` (platform admin login).
 * @returns {Record<string, unknown>|null}
 */
export function getAdminTokenPayload() {
  if (typeof window === 'undefined') return null;
  const raw = localStorage.getItem('adminToken');
  if (raw == null || typeof raw !== 'string' || !String(raw).trim()) return null;
  try {
    return jwt_decode(String(raw).trim());
  } catch {
    return null;
  }
}

/**
 * Roles that may manage plan/subscription "Show setup" in the admin UI (switch stays on, read-only).
 * Other roles cannot turn setup on; saved config uses `showSetup: false`.
 */
export function isAdminModuleFullPlanEditor() {
  const role = String(getAdminTokenPayload()?.userrole || '')
    .toUpperCase()
    .trim();
  return role === 'SUPER_ADMIN' || role === 'ADMIN';
}
